import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

// Funkce pro získání dostupných roků
export const fetchAvailableYears = async () => {
  try {
    const response = await axiosInstance.get(`/api/deposits/years`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání záloh."
    );
    return { success: false, status, message };
  }
};

// Funkce pro získání záloh podle vybraného roku
export const fetchZalohy = async (year, limit) => {
  try {
    const response = await axiosInstance.get(`/api/deposits`, {
      params: { year, limit },
    });
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání záloh."
    );
    return { success: false, status, message };
  }
};

export const fetchDeposit = async () => {
  try {
    const response = await axiosInstance.get(`/api/deposits/deposit`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání měsíční zálohy."
    );
    return { success: false, status, message };
  }
};

export const updateDeposit = async (deposit) => {
  try {
    const response = await axiosInstance.patch(
      "/api/deposits/deposit",
      deposit,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      success: true,
      status: response.status,
    };
  } catch (error) {
    let { status, message } = handleAxiosError(
      error,
      "Chyba při změně výše zálohy."
    );

    if (status === 403) {
      message = "Velkoodběratel nemá možnost změnit výši zálohy.";
    }

    return { success: false, status, message };
  }
};
